import { z } from 'zod';

export const PartnerCloudflareIntegrationSchema = z.object({
  id: z.number(),
  bloom_operator_config_id: z.number(),
  api_token: z.string().nullable(),
  account_id: z.string(),
  zone_id: z.string(),
  name: z.string().nullable(),
  route_pattern: z.string(),
  deploy_robots_txt: z.boolean(),
  status: z.string(),
  last_error_message: z.string().nullable(),
  provisioned_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type PartnerCloudflareIntegration = z.infer<
  typeof PartnerCloudflareIntegrationSchema
>;
